













import { Prop, Component, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import TemplateSearchBarOptions from "../../usecace/template-search-options";

@Component({})
export default class TemplateSearchBar extends Vue {
  @Prop({ required: true }) options!: TemplateSearchBarOptions;
  @Prop({ default: () => [] }) tamplateOptions!: SelectOption[];

  submit() {
    this.$emit("submit", this.options);
  }
}
